import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { loadComprobantesPedidos } from '../../../store/slices/configuracionesSlice';

import Switch from "@mui/material/Switch";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

import Spinner from "../../UI/Spinner/Spinner";

const ComprobantesPedidos = (props) => {
  const dispatch = useDispatch();
  const comprobantes = useSelector(state => state.configuraciones.comprobantesPedidos.items);
  const loading = useSelector(state => state.configuraciones.comprobantesPedidos.loading);
  const onLoad = (empresaId) => dispatch(loadComprobantesPedidos(empresaId));
  const { onChangeValue, empresaId, } = props;

  const enviarValoresTrue = (comprobantes) => {
    return comprobantes.map((comprobante) => {
      if (comprobante.estaSeleccionado)
        return onChangeValue(comprobante);
      return undefined;
    });
  };

  const formatComprobantes = () => {
    const formateoComprobantes = [];
    for (var i = 0; i <= comprobantes.length / 12; i++) {
      formateoComprobantes.push(comprobantes.slice(i * 12, i * 12 + 12));
    }

    return (
      <div style={{ display: "flex" }}>
        {formateoComprobantes.map((comprobantes, key) => (
          <div
            key={key}
            style={{ display: "flex", flexDirection: "column", width: "300px" }}
          >
            {comprobantes.map((comprobante, key) => (
              <FormControlLabel
                key={key}
                control={
                  <Switch
                    key={key}
                    defaultChecked={!comprobante.estaSeleccionado}
                    onChange={() => onChangeValue(comprobante)}
                  />
                }
                label={comprobante.nombre.trim()}
              />
            ))}
          </div>
        ))}
      </div>
    );
  };

  useEffect(() => {
    onLoad(empresaId);
  }, [empresaId]);

  useEffect(() => {
    enviarValoresTrue(comprobantes);
  }, [loading]);

  return (
    <div style={{ minHeight: props.loading ? "205px" : "0px" }}>
      {props.loading ? (
        <Spinner />
      ) : (
        <FormControl component="fieldset">
          <FormGroup>{formatComprobantes()}</FormGroup>
        </FormControl>
      )}
    </div>
  );
};

export default ComprobantesPedidos;